'use strict';
const $ = require('jquery');


/**
 * Backbone does not have a native way to listen for a "Remove Event"
 * when any View is removed. If your View has some kind of Pooling or
 * Timer, it is handy to have a trigger stopping these processes
 * and preventing memory leaks.
 *
 * this plugin will dispatch a custom jQuery event when a DOM is removed
 * which we can listen on in our view
 *
 * i.e.
 *
 * var MainView = Backbone.View.extend({
*   initialize : function(){
*     _.bindAll(this);
*     this.$el.on('destroyed', this.removeHandler);
*   },
*   removeHandler : function(){
*     console.log('View has been destroyed, do we need to stop any Timer?');
*   }
* });
 *
 */
$.event.special.destroyed = {
    remove: function (o) {
        if (o.handler) {
            o.handler();
        }
    }
};

/**
 * jQuery plugin
 * Mobile Web - Disable long-touch/taphold text selection
 *
 * code snippet from https://stackoverflow.com/questions/11237936/mobile-web-disable-long-touch-taphold-text-selection
 * https://jsfiddle.net/ebEqu/1/
 * usage $('.notSelectable').disableSelection();
 *
 */
$.fn.extend({
    disableSelection: function () {
        this.each(function () {
            this.onselectstart = function () {
                return false;
            };
            this.unselectable = 'on';
            $(this).css('-moz-user-select', 'none');
            $(this).css('-webkit-user-select', 'none');
        });
    }
});

/**
 * jQuery alterClass plugin
 *
 * Remove element classes with wildcard matching. Optionally add classes:
 *   $( '#foo' ).alterClass( 'foo-* bar-*', 'foobar' )
 *
 * https://gist.github.com/peteboere/1517285
 *
 * Copyright (c) 2011 Pete Boere (the-echoplex.net)
 * Free under terms of the MIT license: https://www.opensource.org/licenses/mit-license.php
 *
 */
$.fn.alterClass = function (removals, additions) {

    var self = this;

    if (removals.indexOf('*') === -1) {
        // Use native jQuery methods if there is no wildcard matching
        self.removeClass(removals);
        return !additions ? self : self.addClass(additions);
    }

    var patt = new RegExp('\\s' +
        removals.
            replace(/\*/g, '[A-Za-z0-9-_]+').
            split(' ').
            join('\\s|\\s') +
        '\\s', 'g');

    self.each(function (i, it) {
        var cn = ' ' + it.className + ' ';
        while (patt.test(cn)) {
            cn = cn.replace(patt, ' ');
        }
        it.className = $.trim(cn);
    });

    return !additions ? self : self.addClass(additions);
};


/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * https://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */

$.fn.unveil = function(threshold, callback) {

  var $w = $(window),
      th = threshold || 0,
      retina = window.devicePixelRatio > 1,
      attrib = retina? "data-src-retina" : "data-src",
      images = this,
      loaded;

  this.on("unveil", function() {
    var source = this.getAttribute(attrib);
    source = source || this.getAttribute("data-src");
    if (source) {
      this.setAttribute("src", source);
      if (typeof callback === "function") callback.call(this);
    }
  });

  function unveil() {
    var inview = images.filter(function() {
      var $e = $(this);
      if ($e.is(":hidden")) return;

      var wt = $w.scrollTop(),
          wb = wt + $w.height(),
          et = $e.offset().top,
          eb = et + $e.height();

      return eb >= wt - th && et <= wb + th;
    });

    loaded = inview.trigger("unveil");
    images = images.not(loaded);
  }

  $w.on("scroll.unveil resize.unveil lookup.unveil", unveil);

  unveil();

  return this;

};


// WEBPACK FOOTER //
// ./app/scripts/util/plugin.js